export default "__VITE_ASSET__Bh8ZRq9C__"